import React from "react";
import { Container, Typography, Grid, Box } from "@mui/material";

import img1 from "../../pictures/img1.jpg";
import img2 from "../../pictures/img3.jpg";
import img3 from "../../pictures/img4.jpg";

function ProjectDetails() {

  const images = [img1, img2, img3];

  return (

    <Container sx={{ py: 8 }}>

      <Typography variant="h4" fontWeight="bold" mb={4}>
        Residential Villa Project
      </Typography>

      {/* Image Gallery */}

      <Grid container spacing={3}>

        {images.map((img, index) => (

          <Grid item xs={12} sm={6} md={4} key={index}>

            <Box
              component="img"
              src={img}
              sx={{
                width: "100%",
                borderRadius: 2,
                transition: "0.4s",
                "&:hover": {
                  transform: "scale(1.05)"
                }
              }}
            />

          </Grid>

        ))}

      </Grid>

      {/* Project Details */}

      <Box mt={5}>

        <Typography variant="h6" fontWeight="bold">
          Project Details
        </Typography>

        <Typography mt={2}>
          This residential villa project was completed with modern architecture
          and high quality construction materials. The project includes
          spacious living areas, parking facilities and green landscape design.
        </Typography>

      </Box>

    </Container>
  );
}

export default ProjectDetails;